<template lang="pug">
ul.wagtail-list
    li.wagtail-list-item(v-for="item,index in value.content" :key="index") {{ item }}
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>